<template>
  <div class="grid-map-menu-body">
    <component
      :is="scrollbarTag"
      class="grid-map-scroll-area--customizer aisea-pt-2"
      :settings="settings"
      :key="$vs.rtl"
    >
      <filter-card
        filterType="vessel"
        filterTitle="船舶種別"
        :filterList="vesselListForDisp"
        :isSmallIcon="isSmallIcon"
        :updateFilterSettings="updateFilterSettings"
      />
      <filter-card
        filterType="plot"
        filterTitle="プロット種別"
        :filterList="plotListForDisp"
        :isSmallIcon="!isSmallIcon"
        :updateFilterSettings="updateFilterSettings"
      />
      <div v-if="getAddonFlag('GKMG_PRIVATE_PLOT')">
        <filter-card
          filterType="privatePlot"
          filterTitle="プライベートプロット種別"
          :filterList="privatePlotListForDisp"
          :isSmallIcon="!isSmallIcon"
          :updateFilterSettings="updateFilterSettings"
        />
      </div>
      <filter-card
        filterType="navigation"
        filterTitle="航路標識種別"
        :filterList="navigationListForDisp"
        :isSmallIcon="!isSmallIcon"
        :updateFilterSettings="updateFilterSettings"
      />
    </component>
  </div>
</template>

<script>
/**
 * マップ右メニューのフィルター全体を描画するためのコンポーネント
 * @parent O.RightMenuBase
 */
import { createNamespacedHelpers, mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FilterCard from "@/components/molecules/FilterCard";
import FireStoreService from "@/services/fireStoreService";
import {
  VESSEL_CATEGORY,
  PLOT_PARENT_CATEGORY,
  NAVIGATIONS_CATEGORY,
} from "@/config/const";

const { mapState: mapStateOfGridMap, mapMutations: mapMutationsOfGridMap } =
  createNamespacedHelpers("gridMap");

export default {
  name: "O.FilterMap",
  components: {
    VuePerfectScrollbar,
    FilterCard,
  },
  props: {
    /** スクロールの設定 */
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSmallIcon: true,
      // 船舶種別のデータ
      vesselList: [
        {
          id: VESSEL_CATEGORY.TANKER,
          iconPath: require("@/assets/images/icons/vessels/TankerInactive.png"),
          name: "タンカー船",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.CARGO,
          iconPath: require("@/assets/images/icons/vessels/CargoInactive.png"),
          name: "貨物船",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.TUGBOAT,
          iconPath: require("@/assets/images/icons/vessels/TugInactive.png"),
          name: "タグボート",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.CRUISE,
          iconPath: require("@/assets/images/icons/vessels/PassengerInactive.png"),
          name: "旅客船",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.FISHING,
          iconPath: require("@/assets/images/icons/vessels/FishingInactive.png"),
          name: "漁船",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.PLEASURE,
          iconPath: require("@/assets/images/icons/vessels/PleasureBoatInactive.png"),
          name: "プレジャーボート",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.JET_SKI,
          iconPath: require("@/assets/images/icons/vessels/BikeInactive.png"),
          name: "ジェットスキー",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.WORK,
          iconPath: require("@/assets/images/icons/vessels/WorkInactive.png"),
          name: "作業船",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.SAILBOAT,
          iconPath: require("@/assets/images/icons/vessels/SailboatInactive.png"),
          name: "ヨット",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.BARGE,
          iconPath: require("@/assets/images/icons/vessels/BargeInactive.png"),
          name: "バージ",
          switchStatus: false,
        },
        {
          id: VESSEL_CATEGORY.OTHER,
          iconPath: require("@/assets/images/icons/vessels/OtherInactive.png"),
          name: "その他",
          switchStatus: false,
        },
      ],
      // プロット種別のデータ
      plotList: [
        {
          id: PLOT_PARENT_CATEGORY.CONSTRUCTION,
          iconPath: require("@/assets/images/plot/childCategory/UnderConstruction_w@96x-8.png"),
          name: "工事区域",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.RESTRICTION,
          iconPath: require("@/assets/images/plot/childCategory/LimitedNavigationArea_w@96x-8.png"),
          name: "航行制限区域",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.USEFUL,
          iconPath: require("@/assets/images/plot/childCategory/LeisureSpot_w@96x-8.png"),
          name: "お役立ち",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.ATTENTION,
          iconPath: require("@/assets/images/plot/childCategory/Shallows_w@96x-8.png"),
          name: "注意",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.EMERGENCY,
          iconPath: require("@/assets/images/plot/childCategory/AccidentReport_w@96x-8.png"),
          name: "緊急",
          switchStatus: false,
        },
      ],
      // プライベートプロット種別のデータ
      privatePlotList: [
        {
          id: PLOT_PARENT_CATEGORY.CONSTRUCTION,
          iconPath: require("@/assets/images/plot/childCategory/UnderConstruction_w@96x-8.png"),
          name: "工事区域",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.RESTRICTION,
          iconPath: require("@/assets/images/plot/childCategory/LimitedNavigationArea_w@96x-8.png"),
          name: "航行制限区域",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.USEFUL,
          iconPath: require("@/assets/images/plot/childCategory/LeisureSpot_w@96x-8.png"),
          name: "お役立ち",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.ATTENTION,
          iconPath: require("@/assets/images/plot/childCategory/Shallows_w@96x-8.png"),
          name: "注意",
          switchStatus: false,
        },
        {
          id: PLOT_PARENT_CATEGORY.EMERGENCY,
          iconPath: require("@/assets/images/plot/childCategory/AccidentReport_w@96x-8.png"),
          name: "緊急",
          switchStatus: false,
        },
      ],
      // 航路標識種別のリスト
      navigationList: [
        {
          id: NAVIGATIONS_CATEGORY.LIGHTHOUSE,
          iconPath: require("@/assets/images/navigations/navigationalAidsLighthouse.svg"),
          name: "灯台",
          switchStatus: false,
        },
        {
          id: NAVIGATIONS_CATEGORY.LIGHT_BUOY,
          iconPath: require("@/assets/images/navigations/navigationalAidsLightBuoy.svg"),
          name: "灯浮標",
          switchStatus: false,
        },
        {
          id: NAVIGATIONS_CATEGORY.LIGHT_BEACON,
          iconPath: require("@/assets/images/navigations/navigationalAidsLightBeacon.svg"),
          name: "灯標",
          switchStatus: false,
        },
        {
          id: NAVIGATIONS_CATEGORY.OTHER,
          iconPath: require("@/assets/images/navigations/navigationalAidsOther.svg"),
          name: "その他",
          switchStatus: false,
        },
        {
          id: NAVIGATIONS_CATEGORY.MARITIME_TRAFFIC_REGULATIONS_ROUTE,
          iconPath: require("@/assets/images/navigations/maritimeTrafficRegulations.svg"),
          name: "海上交通安全法の航路",
          switchStatus: false,
        },
        {
          id: NAVIGATIONS_CATEGORY.PORT_TRAFFIC_REGULATIONS_ROUTE,
          iconPath: require("@/assets/images/navigations/portTrafficRegulations.svg"),
          name: "港則法の航路",
          switchStatus: false,
        },
      ],
    };
  },
  computed: {
    ...mapStateOfGridMap({
      allGridMapSettings: (state) => state.allGridMapSettings,
      activeSidebarForGrid: (state) => state.activeSidebarForGrid,
    }),
    ...mapGetters(["getAddonFlag"]),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    mapId() {
      if (!this.activeSidebarForGrid) return "";
      return this.activeSidebarForGrid.mapId;
    },
    gridMapSetting() {
      return this.allGridMapSettings.find((gms) => gms.map_id === this.mapId);
    },
    /** フィルターオンにする船舶のリスト */
    vesselListForDisp() {
      const { gridMapSetting, vesselList } = this;
      if (!gridMapSetting) {
        return vesselList.map((vessel) => {
          return {
            ...vessel,
            switchStatus: false,
          };
        });
      }
      return vesselList.map((vessel) => {
        return {
          ...vessel,
          switchStatus: gridMapSetting.filter_vessels.includes(
            String(vessel.id),
          ),
        };
      });
    },
    /** フィルターオンにするプロットのリスト */
    plotListForDisp() {
      const { gridMapSetting, plotList } = this;
      if (!gridMapSetting) {
        return plotList.map((plot) => {
          return {
            ...plot,
            switchStatus: false,
          };
        });
      }
      return plotList.map((plot) => {
        return {
          ...plot,
          switchStatus: gridMapSetting.filter_plots.includes(String(plot.id)),
        };
      });
    },
    /** フィルターオンにするプライベートプロットのリスト */
    privatePlotListForDisp() {
      const { gridMapSetting, privatePlotList } = this;
      if (!gridMapSetting) {
        return privatePlotList.map((plot) => {
          return {
            ...plot,
            switchStatus: false,
          };
        });
      }
      return privatePlotList.map((plot) => {
        return {
          ...plot,
          switchStatus: gridMapSetting.filter_private_plots.includes(
            String(plot.id),
          ),
        };
      });
    },
    /** フィルターオンにする標識のリスト */
    navigationListForDisp() {
      const { gridMapSetting, navigationList } = this;
      if (!gridMapSetting) {
        return navigationList.map((navigation) => {
          return {
            ...navigation,
            switchStatus: false,
          };
        });
      }
      return navigationList.map((navigation) => {
        return {
          ...navigation,
          switchStatus: gridMapSetting.filter_navigations.includes(
            String(navigation.id),
          ),
        };
      });
    },
  },
  methods: {
    ...mapMutationsOfGridMap(["UPDATE_GRID_MAP_SETTINGS"]),
    /**
     * フィルターの変更を反映する
     * {
     *   type: vessel, plot, navigation
     *   id: typeに紐づくID or null
     *   status: true(マップに表示), false(マップ非表示)
     *   isAll: true(一括)、false(個別)
     * }
     */
    async updateFilterSettings(param) {
      if (param.type === "vessel") {
        // 船舶更新
        await this.updateVesselSettings(this.mapId, param);
      }
      if (param.type === "plot") {
        // プロット更新
        await this.updatePlotSettings(this.mapId, param);
      }
      if (param.type === "privatePlot") {
        // プライベートプロット更新
        await this.updatePrivatePlotSettings(this.mapId, param);
      }
      if (param.type === "navigation") {
        // 航路標識種別更新
        await this.updateNavigationSettings(this.mapId, param);
      }
    },

    /** 船舶の更新 */
    async updateVesselSettings(mapId, param) {
      // 修正前のリスト
      let vesselList = [
        ...new Set(
          this.allGridMapSettings.find((setting) => setting.map_id === mapId)
            .filter_vessels || [],
        ),
      ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      // 全更新、オフ
      if (param.isAll && !param.status) {
        vesselList = [];
      }
      // 全更新、オン
      if (param.isAll && param.status) {
        vesselList = [
          ...new Set(this.vesselList.map((e) => String(e.id))),
        ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      }
      // 個別更新、オフ
      if (!param.isAll && !param.status) {
        vesselList = [
          ...new Set(vesselList.filter((vessel) => vessel !== param.id)),
        ];
      }
      // 個別更新、オン
      if (!param.isAll && param.status) {
        const target = vesselList.indexOf(String(param.id));
        if (target === -1) {
          vesselList.push(String(param.id));
        }
      }
      /** store更新 */
      this.UPDATE_GRID_MAP_SETTINGS({
        map_id: mapId,
        filter_vessels: vesselList,
      });
      /** FireStore更新 */
      await FireStoreService.setGridMapSettings(mapId, {
        filter_vessels: vesselList,
      });
    },
    /** プロットの更新 */
    async updatePlotSettings(mapId, param) {
      // 修正前のリスト
      let plotList = [
        ...new Set(
          this.allGridMapSettings.find((setting) => setting.map_id === mapId)
            .filter_plots || [],
        ),
      ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      // 全更新、オフ
      if (param.isAll && !param.status) {
        plotList = [];
      }
      // 全更新、オン
      if (param.isAll && param.status) {
        plotList = [...new Set(this.plotList.map((e) => String(e.id)))].sort(
          (a, b) => parseInt(a, 10) - parseInt(b, 10),
        );
      }
      // 個別更新、オフ
      if (!param.isAll && !param.status) {
        plotList = [...new Set(plotList.filter((plot) => plot !== param.id))];
      }
      // 個別更新、オン
      if (!param.isAll && param.status) {
        const target = plotList.indexOf(String(param.id));
        if (target === -1) {
          plotList.push(String(param.id));
        }
      }
      /** store更新 */
      this.UPDATE_GRID_MAP_SETTINGS({ map_id: mapId, filter_plots: plotList });
      /** FireStore更新 */
      await FireStoreService.setGridMapSettings(mapId, {
        filter_plots: plotList,
      });
    },
    /** プライベートプロットの更新 */
    async updatePrivatePlotSettings(mapId, param) {
      // 修正前のリスト
      let privatePlotList = [
        ...new Set(
          this.allGridMapSettings.find((setting) => setting.map_id === mapId)
            .filter_private_plots || [],
        ),
      ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      // 全更新、オフ
      if (param.isAll && !param.status) {
        privatePlotList = [];
      }
      // 全更新、オン
      if (param.isAll && param.status) {
        privatePlotList = [
          ...new Set(this.privatePlotList.map((e) => String(e.id))),
        ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      }
      // 個別更新、オフ
      if (!param.isAll && !param.status) {
        privatePlotList = [
          ...new Set(privatePlotList.filter((plot) => plot !== param.id)),
        ];
      }
      // 個別更新、オン
      if (!param.isAll && param.status) {
        const target = privatePlotList.indexOf(String(param.id));
        if (target === -1) {
          privatePlotList.push(String(param.id));
        }
      }
      /** store更新 */
      this.UPDATE_GRID_MAP_SETTINGS({
        map_id: mapId,
        filter_private_plots: privatePlotList,
      });
      /** FireStore更新 */
      await FireStoreService.setGridMapSettings(mapId, {
        filter_private_plots: privatePlotList,
      });
    },
    /** 標識の更新 */
    async updateNavigationSettings(mapId, param) {
      // 修正前のリスト
      let navigationList = [
        ...new Set(
          this.allGridMapSettings.find((setting) => setting.map_id === mapId)
            .filter_navigations || [],
        ),
      ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      // 全更新、オフ
      if (param.isAll && !param.status) {
        navigationList = [];
      }
      // 全更新、オン
      if (param.isAll && param.status) {
        navigationList = [
          ...new Set(this.navigationList.map((e) => String(e.id))),
        ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      }
      // 個別更新、オフ
      if (!param.isAll && !param.status) {
        navigationList = [
          ...new Set(
            navigationList.filter((navigation) => navigation !== param.id),
          ),
        ];
      }
      // 個別更新、オン
      if (!param.isAll && param.status) {
        const target = navigationList.indexOf(String(param.id));
        if (target === -1) {
          navigationList.push(String(param.id));
        }
      }
      /** store更新 */
      this.UPDATE_GRID_MAP_SETTINGS({
        map_id: mapId,
        filter_navigations: navigationList,
      });
      /** FireStore更新 */
      await FireStoreService.setGridMapSettings(mapId, {
        filter_navigations: navigationList,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";
</style>
